var cilRoom = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M440,424V88H352V13.005L88,58.522V424H16v32h86.9L352,490.358V120h56V456h88V424ZM320,453.642,120,426.056V85.478L320,51Z' class='ci-primary'/><rect width='32' height='64' x='256' y='232' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilRoom };

